export const START_GET_COLLAB_POSTS = "START_GET_COLLAB_POSTS";
export const SUCCESS_GET_COLLAB_POSTS = "SUCCESS_GET_COLLAB_POSTS";
export const ERROR_GET_COLLAB_POSTS = "ERROR_GET_COLLAB_POSTS";

export const START_COLLAB_POSTS_ACTION = "START_COLLAB_POSTS_ACTION";
export const SUCCESS_COLLAB_POSTS_ACTION = "SUCCESS_COLLAB_POSTS_ACTION";
export const ERROR_COLLAB_POSTS_ACTION = "ERROR_COLLAB_POSTS_ACTION";
